import {Template} from '@dv5/domain'
import React, {FC} from 'react'

interface Props {
    data: Template['templateData']
}

export const JsonTemplateView: FC<Props> = ({data}) => {
    return (
        <pre className="template-data-json">{JSON.stringify(data, null, 2)}</pre>
    )
}
